import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ElectronicConsultationService } from '../../services/electronic-consultation.service';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { PagingService } from '../../../../shared/Services/PagingService';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { AddElectronicConsultationComponent } from '../add-electronic-consultation/add-electronic-consultation.component';
import { GetElectronicConsultationDetailsComponent } from '../get-electronic-consultation-details/get-electronic-consultation-details.component';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'get-electronic-consultation',
  templateUrl: './get-electronic-consultation.component.html',
  styleUrls: ['./get-electronic-consultation.component.scss']
})
export class GetElectronicConsultationComponent extends BaseComponent implements OnInit {
form: FormGroup;
    constructor(
      public service: ElectronicConsultationService,
      route: Router,
      private diag: NbDialogService,
      private toast: NbToastrService,
      private fb: FormBuilder,
      private paging: PagingService
    ) {
      super(route, service, paging);
    }

   ngOnInit() {
      this.intitForm();
      this.loadEntities();
    }

    handleSearch() {
    if (!this.form.value.titleAR) {
      this.toast.danger('برجاء إدخال العنوان لإتمام عملية البحث', 'رسالة تحذيرية');
      return;
    }

    let serchTermArr = [];

    if (this.form.value.titleAR.trim()) {
      let title = this.form.value.titleAR.trim();
      this.form.controls['titleAR'].setValue(title);
      serchTermArr.push(`titleAR:${title}`);
    }

    this.loadEntitiesWithFilter(serchTermArr.join(','));
  }
    clearFilter() {
      this.form.controls['titleAR'].setValue('');
      this.loadEntitiesWithFilter('');
    }


    addelectronicconsultation() {
      this.diag
        .open(AddElectronicConsultationComponent, {
          dialogClass: 'custom-dialog-height',
        })
        .onClose.subscribe((res) => {
          if (res === 'true') this.loadEntities();
        });
    }


detail(model) {
      this.diag.open(GetElectronicConsultationDetailsComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: model,
        },
      });
    }

    update(model) {
      const copymodel = {...model}
      this.diag
        .open(AddElectronicConsultationComponent, {
          dialogClass: 'custom-dialog-height',
          context: {
            model: copymodel,
            isEdit: true,
          },
        })
        .onClose.subscribe((res) => {
          if (res === 'true') this.loadEntities();
        });
    }
    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }

loadEntities() {

      if (this.isAuthorized) {
        this.service.get(this.pagingModel.query).subscribe(
          (res) => {
            this.initiResponse(res);
            this.finishLoading = true;
          },
          (error) => {
            this.finishLoading = true;
          }
        );
      }
    }
  
    intitForm() {
      this.form = this.fb.group({
        titleAR: [''],
      });
    }
}


